import { Component, HostListener, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { NegotiationStatus } from '@app-model/evaluation';
import { EvaluationService } from '@app-services/evaluation.service';

export interface DialogNegotiationStatusCardData {
  vehicleId: string;
  negotiationStatus: NegotiationStatus | null;
}

export interface DialogNegotiationStatusCardResult {
  negotiationStatus?: NegotiationStatus;
}

interface NegotiationStatusOption {
  key: NegotiationStatus;
  label: string;
  icon: string;
  class: string;
}

@Component({
  selector: 'app-dialog-negotiation-status-card',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './dialog-negotiation-status-card.component.html',
  styleUrls: ['./dialog-negotiation-status-card.component.scss'],
})
export class DialogNegotiationStatusCardComponent {
  private readonly dialogRef = inject(MatDialogRef<DialogNegotiationStatusCardComponent, DialogNegotiationStatusCardResult>);
  private readonly data = inject<DialogNegotiationStatusCardData>(MAT_DIALOG_DATA);
  private readonly evaluationService = inject(EvaluationService);

  readonly statusOptions: NegotiationStatusOption[] = [
    { key: NegotiationStatus.COLD, label: 'FRIO', icon: 'fa-temperature-frigid', class: 'cold' },
    { key: NegotiationStatus.TEPID, label: 'MORNO', icon: 'fa-temperature-low', class: 'tepid' },
    { key: NegotiationStatus.HOT, label: 'QUENTE', icon: 'fa-temperature-hot', class: 'hot' },
    { key: NegotiationStatus.DEAL_DONE, label: 'DEU NEGÓCIO', icon: 'fa-handshake', class: 'deal-done' },
  ];

  statusSelected: NegotiationStatus | null = null;
  loading = false;

  constructor() {
    this.statusSelected = this.data.negotiationStatus;
  }

  selectStatus(status: NegotiationStatus): void {
    this.statusSelected = status;
  }

  close(): void {
    this.dialogRef.close({ negotiationStatus: undefined });
  }

  @HostListener('window:keyup.esc')
  onEsc(): void {
    this.close();
  }

  confirm(): void {
    if (!this.statusSelected || this.loading) return;

    this.loading = true;
    this.evaluationService
      .sendNegotiationStatus(this.data.vehicleId, this.statusSelected)
      .subscribe({
        next: () => this.dialogRef.close({ negotiationStatus: this.statusSelected! }),
        error: () => {
          this.loading = false;
        },
      });
  }
}
